import type { UnitInterface } from 'store/units/types';
import { UnitTypes } from 'unitData/types';

export const isMobileUnit = (unitType: UnitTypes) => {
  return [
    UnitTypes.MOBILE_TRACKED_CONE,
    UnitTypes.MOBILE_WHEELED_CONE,
    UnitTypes.MOBILE_TRACKED_JAW,
    UnitTypes.MOBILE_TRACKED_SCREEN,
    UnitTypes.MOBILE_WHEELED_SCREEN,
    UnitTypes.MOBILE_TRACKED_HSI,
    UnitTypes.MOBILE_WHEELED_HSI,
    UnitTypes.MOBILE_VSI,
    UnitTypes.MOBILE_JAW_AND_CONE,
    UnitTypes.MOBILE_WHEELED_JAW,
    UnitTypes.MOBILE_JAW_COMMON,
    UnitTypes.MOBILE_CONE_COMMON,
    UnitTypes.MOBILE_SCREEN_COMMON,
    UnitTypes.MOBILE_HSI_COMMON,
  ].some((t) => t === unitType);
};

export const isFeed = (unit: UnitInterface) => unit.type === UnitTypes.FEED;
export const isGenericCrusher = (unit: UnitInterface) =>
  unit.type === UnitTypes.GENERIC_CRUSHER;

export const hasPsdData = (unit: UnitInterface) => {
  return isFeed(unit) || isGenericCrusher(unit);
};
